<template>
  <div class="unlock-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <div class="unlock-inner">
      <svg width="35" height="50" viewBox="0 0 35 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.2083 11.7647C10.2083 7.70221 13.4714 4.41176 17.5 4.41176C21.3372 4.41176 24.4818 7.3989 24.7734 11.1949C24.8646 12.4081 25.9219 13.318 27.125 13.2261C28.3281 13.1342 29.2305 12.068 29.1393 10.8548C28.6654 4.77941 23.6432 0 17.5 0C11.056 0 5.83333 5.26654 5.83333 11.7647V17.6471C2.61589 17.6471 0 20.2849 0 23.5294V44.1176C0 47.3621 2.61589 50 5.83333 50H29.1667C32.3841 50 35 47.3621 35 44.1176V23.5294C35 20.2849 32.3841 17.6471 29.1667 17.6471H10.2083V11.7647ZM5.83333 22.0588H10.2083H29.1667C29.9688 22.0588 30.625 22.7206 30.625 23.5294V44.1176C30.625 44.9265 29.9688 45.5882 29.1667 45.5882H5.83333C5.03125 45.5882 4.375 44.9265 4.375 44.1176V23.5294C4.375 22.7206 5.03125 22.0588 5.83333 22.0588Z" fill="url(#paint0_linear_2888_628)"/>
        <defs>
          <linearGradient id="paint0_linear_2888_628" x1="1.04308e-06" y1="50" x2="35" y2="1.53482e-06" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA86D"/>
            <stop offset="1" stop-color="#F8CF11"/>
          </linearGradient>
        </defs>
      </svg>

      <h2>Unlock {{ opts.name }}?</h2>
      <p>You have {{ unlocksAvailable }} unlocks available. Use one now to start reading this stack?</p>
      <p>{{ opts.name }} will be unlocked forever, and you can come back and watch or read this stack at any time.</p>
    </div>

    <div class="actions">
      <button @click="unlock()">
        <span v-if="isUnlocking" class="loader"></span>
        <span v-else>Unlock {{ opts.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  import API from 'app/axios';

  export default {
    data() {
      return {
        isUnlocking: false
      }
    },

    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      unlocksAvailable() {
        return this.getAccount?.system?.unlocks;
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      unlock() {
        this.isUnlocking = true;

        API
        .patch(`/home/stack-manage/${this.opts.slug}`, {
          task: 'unlock'
        })
        .then(async () => {
          await API.getStackShelves();
          this.isUnlocking = false;
          this.$userEngine.reload();
          this.$emit('close');
        })
        .catch((response) => {
          this.isUnlocking = false;
          console.error(response)
        }); 
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .unlock-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    padding: 1.5rem 1.5rem 2.5rem 1.5rem;
    color: white;
    background: black;
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
    }

    .unlock-inner {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      padding-bottom: 1.5rem;
      width: 100%;

      svg {
        margin-bottom: 1rem;
      }

      h2 {
        font-family: 'Brawler';
        font-size: 2rem;
        font-weight: normal;
      }

      p {
        font-size: 1.1rem;
      }
    }

    .actions {
      display: flex;
      width: 100%;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;
        width: 100%;
        background: url(@assets/images/n25xo/banner-bg-light.jpg);
        background-size: cover;
        color: rgba(0,0,0);

        svg path {
          fill: rgb(0,0,0);
        }
      }
    }
  }

  .loader {
    width: 1.5rem;
    height: 1.5rem;
    border: 4px solid rgba(0,0,0);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 0.75s linear infinite;
  }

  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
</style>